<template>
        <a class="btn btn-default" href="#" @click="remove()">
            <i class="fa fa-trash"></i> Delete
        </a>
</template>
<script>
    export default {

        props:{

            project:{
                type: Object,
                required: true,
            },
            space:{
                type: Object,
                required: true,
            },
        },

        methods:{
            remove(){
                Alert.confirmation('Do you really want to delete this space?', 'question').then(() => {
                    axios.delete(`/projects/${this.project.slug}/spaces/${this.space.slug}`).then(response => {
                        Alert.withAction('The space has been removed!').then(() => {
                            this.redirectTo(`/projects/${this.project.slug}`)
                        })
                    })
                })
            }
        }
    }
</script>
